import type { ReactNode } from 'react'
import { Gallery as PhotoSwipeGallery } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'

export type GalleryProps = {
  settings?: any
  children: ReactNode
}

export const Gallery = ({ children, settings }: GalleryProps) => {
  const defaultSettings = {
    gallery: {
      zoom: true,
      initialZoomLevel: 'fit',
      close: true,
      counter: true,
      arrowKeys: true
    },
    ...settings
  }

  return (
    <PhotoSwipeGallery options={defaultSettings} withDownloadButton>
      {children}
    </PhotoSwipeGallery>
  )
}
